import * as React from "react";
import { connect } from "react-redux";
import qs from "qs";
import PropTypes from "prop-types";
import { portfolioAction } from "../../actions/portfolio.action";
import Calculating from "../../components/Loading/Calculating";
import PercentageNumber from "../../components/UI/PercentageNumber";
import CyPortfolioDetailsSortable from "../../components/Charts/CyPortfolioDetailsSortable";
import CyPortfolioRiskMetrics from "../../components/Charts/CyPortfolioRiskMetrics";
import CyPortfolioOverview from "../../components/Charts/CyPortfolioOverview";
import CyLineChart from "../../components/Charts/CyLineChart";
import { appAction } from "../../actions/app.action";
import CyComparison from "../../components/Charts/CyComparison";
import SectionHeader from "../../components/UI/SectionHeader";
import SectionCaption from "../../components/UI/SectionCaption";
import OnboardBar from "../../components/UI/OnboardBar";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid/Grid";
import Paper from "@material-ui/core/Paper/Paper";
import Typography from "@material-ui/core/Typography/Typography";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody/TableBody";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import SeeImportantDisclosures from "../../components/UI/SeeImportantDisclosures";
import SummaryDisclosures from "../../components/Content/SummaryDisclosures";
import SummaryPDFCoverPage from "../../components/Content/SummaryPDFCoverPage";
import {
  END_OF_CPR_YEAR,
  generateChartData,
  getRiskPeriod,
  getRiskPeriodLossTolerance,
} from "../../utilities/cpr";
import { withRouter } from "react-router-dom";
import moment from "moment";
import OnboardPortfoliosDialog from "../../components/OnboardPortfoliosDialog";
import RRoR from "../../components/UI/RRoR";
import CyPortfolioCalendarYearReturnTable from "../../components/Charts/CyPortfolioCalendarYearReturnTable";
import { PortfolioFeeSummary } from "../Cy/components";
import CyPortfolioModelConstituentDisclosure from "../../components/Charts/CyPortfolioModelConstituentDisclosure";
import CurrencyNumber from "../../components/UI/CurrencyNumber";
import CyPortfolioReturn from "../../components/Charts/CyPortfolioReturn";
import HighLevelDisclosure from "../SummaryPDF/components/HighLevelDisclosure";
import CyTotalIncomeChart from "../../components/Charts/CyTotalIncomeChart";
import { downloadBlob } from "../../utilities/download-blob";
import { getValidAdvisorFees } from "../../utilities/validators";
import CyMonteCarlo from "../../components/Charts/CyMonteCarlo";
import {RESTRICTED_BROKERS} from "../../utilities/constant";
import { isBasicView } from "../../utilities/access";

const styles = (theme) => ({
  sectionHeading: {
    fontWeight: "700",
    marginBottom: 10,
    fontSize: 36,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      fontSize: 29,
    },
  },
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    position: "relative",
    paddingBottom: 60,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      width: "110%",
      textAlign: "justify",
      marginTop: theme.spacing(5),
    },
  },
  floatingActions: {
    position: "fixed",
    top: 15,
    right: 15,
    zIndex: 100, // To appear on top of the line chart's tooltip
  },
  errorPaper: {
    padding: 7,
  },
  contentCaption: {
    marginBottom: 10,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      lineHeight: 1.4,
      fontSize: 10,
    },
  },
  subtitle: {
    fontWeight: 500,
    margin: "30px 0 10px",
  },
  heading: {
    "@media screen and (max-width: 1024px)": {
      paddingRight: "75px",
    },
  },
  summarySection: {
    margin: "40px 0",
  },
  onBoardSection: {
    display: `flex`,
    flexDirection: "column",
    marginTop: 40,
  },
  hiddenPrint: {
    "@media print": {
      display: "none",
    },
  },
  onBoardSectionHeading: {
    fontWeight: "700",
    fontStyle: "italic",
  },
  form: {
    maxWidth: "100%",
    "&.disabled": {
      display: "none",
    },
  },
  row: {
    display: "block",
    flexWrap: "wrap",
    "& button": {
      fontSize: 12,
    },
  },
  input: {
    margin: theme.spacing(1, 0),
    minWidth: 300,
    "& label": {
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
    },
    "& input": {
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
    },
  },
  overviewSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  overviewTable: {
    width: "40%",
    "@media print": {
      width: "75%",
    },
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      width: "100%",
    },
    [theme.breakpoints.down("lg")]: {
      width: "80%",
    },
  },
  tableCell: {
    padding: 2,
    fontSize: 12,
    "&.header": {
      maxWidth: 80,
      fontWeight: 500,
      fontSize: 13,
      wordWrap: "break-word",
      color: theme.palette.primary.main,
      lineHeight: 1.5,
      // textAlign: 'center'
    },
    "&.wrap-cell-highlighted": {
      wordWrap: "break-word",
      maxWidth: 80,
      fontWeight: 500,
    },
    "&.wrap-cell-head": {
      wordWrap: "break-word",
      maxWidth: 140,
    },
  },
  portfolioNumbers: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    "& > div": {
      padding: 30,

      "&:first-child": {
        paddingLeft: "5px",
      },
    },
  },
  value: {
    fontSize: 26,
    fontWeight: 500,
    padding: `10px 0`,
  },
  tabletPrint: {
    display: "none",
    position: "fixed",
    top: "10px",
    right: "10px",
    zIndex: 100, // Appear on top of the recharts tooltip
    "@media screen and (max-width: 1024px)": {
      display: "block",
    },
  },
  checkbox: {
    width: 24,
    height: 24,
    padding: 0,
    marginRight: 10,
    float: "left",
  },
  checkIcon: {
    marginRight: 10,
  },
  mb1: {
    marginBottom: theme.spacing(1),
  },
  mb5: {
    marginBottom: theme.spacing(5),
  },
  link: {
    "&&": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
  },
});

class MissingInfoDialog extends React.Component {
  render() {
    const { isOpen, onClose, onContinue } = this.props;
    return (
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>Missing Profile Information</DialogTitle>
        <DialogContent>
          <p>
            Some required profile information is missing. Please complete your
            client profile to proceed.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onContinue}>Provide Missing Information</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientAcknowledgement: false,
      finishProfile: false,
      isDownloading: false,
      onboardingPortfolios: false,
    };
    const parsedQueryString = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.renderForPdfOutput = !!parsedQueryString.pdfOutput;
    this.onboardedCustodianId =
      !!parsedQueryString.custodianId && Number(parsedQueryString.custodianId);
    this.isDraft = parsedQueryString.isDraft;
  }

  returnToHouseholdPage = () => {
    const { history, currentHouseholdId } = this.props;
    history.push(`/Portal/household/${currentHouseholdId}`);
  };

  componentDidMount() {
    const { currentPortfolioId, currentHouseholdId } = this.props;

    if (currentPortfolioId || currentHouseholdId) {
      this.props.dispatch(
        portfolioAction.getPortfolio(currentPortfolioId, currentHouseholdId)
      );
      // prefetch existing onboarding session
    }
    this.props.dispatch(appAction.toggleMainNav(false));
    this.props.dispatch(appAction.setPortfolioNav(true));
    this.props.dispatch(appAction.showCalculatingState(false));
    this.props.dispatch(appAction.updateProgressStep(5));
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { currentHouseholdId, portfolio } = this.props;

    if (portfolio.currentPortfolio) {
      if (
        portfolio.currentPortfolio.onboardStatus === "onboarded" &&
        !portfolio.currentPortfolio.successorPortfolioId &&
        nextProps.portfolio.currentPortfolio.successorPortfolioId &&
        portfolio.requesting &&
        !nextProps.portfolio.requesting
      ) {
        this.props.history.push(
          `/Portal/household/${this.props.currentHouseholdId}/portfolio/${nextProps.portfolio.currentPortfolio.successorPortfolioId}`
        );
      }

      // Requesting to fetch portfolio when route changes on the summary page with new portfolio id
      if (
        nextProps.currentPortfolioId !== portfolio.currentPortfolio.uuid &&
        !portfolio.requesting &&
        !nextProps.portfolio.requesting
      ) {
        this.props.dispatch(
          portfolioAction.getPortfolio(
            nextProps.currentPortfolioId,
            currentHouseholdId
          )
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.dispatch(appAction.setPortfolioNav(true));
    this.props.dispatch(appAction.showCalculatingState(true));
  }

  checkIsDraft = (currentPortfolio) => {
    if (this.isDraft === "1") {
      return true;
    } else if (this.isDraft === "0") {
      return false;
    } else if (
      currentPortfolio.onboardStatus === "in-review" ||
      currentPortfolio.uuid === undefined
    ) {
      return true;
    } else {
      return false;
    }
  };

  getSummaryPDF = (includeModelConstituentDisclosure) => {
    const { currentPortfolioId, currentHouseholdId } = this.props;
    this.setState({ isDownloading: true }, () => {
      this.props
        .dispatch(
          portfolioAction.getPortfolioPDF(
            [currentPortfolioId],
            currentHouseholdId,
            includeModelConstituentDisclosure,
          )
        )
        .then(async (response) => {
          if (response) {
            await downloadBlob(response, `portfolio-summary.pdf`);
            this.setState({ isDownloading: false });
          }
        });
    });
  };

  sendSummaryPDF = (email) => {
    let { currentPortfolioId, currentHouseholdId } = this.props;
    this.props.dispatch(
      portfolioAction.sendPortfolioPDF(
        currentPortfolioId,
        currentHouseholdId,
        email
      )
    );
  };

  handleOnboard = () => {
    this.setState({ onboardingPortfolios: true });
  };

  changeStrategy = () => {
    const { currentPortfolioId } = this.props;
    if (currentPortfolioId) {
      this.props.dispatch(portfolioAction.changeStrategy(currentPortfolioId));
    }
  };

  render() {
    const {
      app,
      classes,
      brokerDealer,
      currentHouseholdId,
      custodians,
      fee,
      history,
      portfolio,
      portfolioAdvisorFee,
      user,
      accessLevel,
      userCustodianFees,
      userPlatformFees,
      appName
    } = this.props;

    const { onboardingPortfolios } = this.state;
    const currentPortfolio = portfolio && portfolio.currentPortfolio;

    if (!currentPortfolio || app.calculating) {
      return <Calculating />;
    }
    const cprRecommendation = currentPortfolio.cprRecommendation;
    const managerList = cprRecommendation && cprRecommendation.managers;

    const baseChartData = generateChartData(currentPortfolio);
    const annualWithdrawalChartData = !!currentPortfolio.metadata
      .annualWithdrawal
      ? generateChartData(
          currentPortfolio,
          currentPortfolio.metadata.annualWithdrawal
        )
      : null;
    const totalWithdrawal = !!currentPortfolio.metadata.annualWithdrawal
      ? generateChartData(
          currentPortfolio,
          currentPortfolio.metadata.annualWithdrawal,
          true
        )
      : null;

    const useWbiSingleStrategy =
      ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(currentPortfolio.metadata.managerType);

    if (!baseChartData) {
      return null;
    }

    const canOnboard =
      !currentPortfolio.onboarded &&
      !["forms-submitted", "forms-signed", "onboarded"].includes(
        currentPortfolio.onboardStatus
      );
    const hasRepCodes = user.user.repCodes.length > 0;
    const userCustodians = Object.keys(user.user.custodianFees).map(parseFloat);
    const pershing = custodians.find(
      (custodian) => custodian.onboardingStrategy === "pershing"
    );
    const onlyPas =
      userCustodians.some((custodian) => custodian === pershing.id) &&
      userCustodians.length === 1;
    const hasPasRepCode = user.user.repCodes
      .map((repCode) => repCode.custodialRepCode)
      .every((el) => el === null);
    const pasRepCodeValid = hasPasRepCode && onlyPas;

    const strategyStartDate = moment(baseChartData[0].date)
      .startOf("month")
      .subtract(2, "months");

    const onboardedCustodianId =
      (userCustodianFees.hasOwnProperty(this.onboardedCustodianId) &&
        this.onboardedCustodianId) ||
      currentPortfolio.CustodianId;
    const isStrategyChange = !!currentPortfolio.predecessorPortfolioId;

    const benchmarkName = cprRecommendation.summary.benchmark.Name;
    const clientProfileSnapshot = currentPortfolio.clientProfiles ? currentPortfolio.clientProfiles.map(c => ({profile: c})) : currentPortfolio.Household.Clients;


    const advisorFee = getValidAdvisorFees(
      portfolioAdvisorFee,
      fee.advisorFeeRate,
      fee.advisorDefaultFeeRate,
    );

    return (
      // IMPORTANT NOTE: The back-end uses a selector to check for this
      // specific element ID to determine if the summary content has been
      // rendered so a PDF can be generated
      <div
        id="summary-content-wrapper"
        className={`${classes.contentWrapper} ${isBasicView(accessLevel) && classes.hiddenPrint}`}
      >
        {!isBasicView(accessLevel) && (
          <OnboardBar
            portfolioId={currentPortfolio.uuid}
            householdId={currentHouseholdId}
            hideOnboardOption={
              !user.user.approved || pasRepCodeValid || !hasRepCodes
            }
            brokerDealer={brokerDealer}
            onDownload={this.getSummaryPDF}
            onEmail={this.sendSummaryPDF}
            isDownloading={this.state.isDownloading}
            onOnboard={canOnboard ? this.handleOnboard : undefined}
            onStrategyChange={this.changeStrategy}
            showStrategyChangeButton={
              currentPortfolio.onboardStatus === "onboarded" &&
              !currentPortfolio.successorPortfolioId
            }
            isStrategyChange={isStrategyChange}
            portfolio={currentPortfolio}
            custodians={custodians}
            appName={appName}
            modelDisclosureEnabled={app.modelDisclosureEnabled && !RESTRICTED_BROKERS.includes(brokerDealer.name)}
            doSessionId={currentPortfolio.DoSessionId}
            accessLevel={accessLevel}
          />
        )}
        {onboardingPortfolios && (
          <OnboardPortfoliosDialog
            isOpen={true}
            household={currentPortfolio.Household}
            onCancel={() => this.setState({ onboardingPortfolios: false })}
            selectedPortfolios={[currentPortfolio]}
            callbacks={this.returnToHouseholdPage}
            history={this.props.history}
          />
        )}
        <MissingInfoDialog
          isOpen={this.state.finishProfile}
          onClose={() => this.setState({ finishProfile: false })}
          onContinue={() =>
            history.push(`/Portal/household/${currentHouseholdId}/client`)
          }
        />
        <div className={`${classes.hiddenPrint} ${classes.floatingActions}`}>
          <Grid container alignItems="center" spacing={1}>
            {portfolio.gettingSummaryPdfError && (
              <Grid item>
                <Paper className={classes.errorPaper}>
                  <Typography color="error">Unable to generate PDF</Typography>
                </Paper>
              </Grid>
            )}
          </Grid>
        </div>
        <div className={classes.content}>
          <SummaryPDFCoverPage
            isDraft={this.checkIsDraft(currentPortfolio)}
            advisors={currentPortfolio.Household.advisors}
            clients={currentPortfolio.Household.Clients}
            portfolioId={currentPortfolio.uuid}
            portfolioName={currentPortfolio.name}
            scenarioName={cprRecommendation.displayName}
          />
          <SectionHeader text={`Cy Optimized Portfolio Summary`} />
          {!isBasicView(accessLevel) && (
            <React.Fragment>
              <Typography variant="subtitle1">
                <b>{currentPortfolio.Household.name}</b>
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                <b>{currentPortfolio.name} - Hypothetical Illustration</b>
              </Typography>
              <Typography variant="body2" className={classes.contentCaption}>
                <b>
                  {currentPortfolio.Household.Clients[0].profile.firstName}
                  {currentPortfolio.Household.Clients.length > 1 && (
                    <React.Fragment>
                      {" "}
                      and{" "}
                      <span>
                        {currentPortfolio.Household.Clients[1].profile.firstName}
                      </span>
                    </React.Fragment>
                  )}
                  ,{" "}
                </b>
                now let’s review the portfolio that{" "}
                {useWbiSingleStrategy
                  ? "you selected"
                  : `Cy optimized for you`}{" "}
                today. We will also review the information you provided{" "}
                {useWbiSingleStrategy ? "" : "to Cy"} which was used to
                optimize the portfolio and provide you some additional information
                regarding the strategy selections as well. If everything looks good,
                we can begin the onboarding process.
              </Typography>
              <Typography variant="body2" className={classes.contentCaption}>
                We believe the most important thing you can do as an investor is
                determine your Loss Tolerance. Based on what you entered, your Loss
                Tolerance for {getRiskPeriod(currentPortfolio.metadata.riskPeriod)}{" "}
                is{" "}
                <b>
                  <PercentageNumber
                    value={currentPortfolio.metadata.risk}
                    showSign={true}
                  />
                </b>
                .&nbsp;
                {useWbiSingleStrategy ? "We" : "Cy"} also estimated that you
                need a{" "}
                <b>
                  <RRoR rrorValue={currentPortfolio.metadata.rror} />
                </b>{" "}
                annualized rate of return on investments over time to meet your
                retirement goals (your Required Rate of Return).
              </Typography>
              <Typography variant="body2" className={classes.contentCaption}>
                Most investors compare their portfolio results to the market. A
                popular benchmark for the market is the {benchmarkName}. Let’s see
                how the hypothetical performance and risk characteristics compare
                between your proposed portfolio and the {benchmarkName} since{" "}
                {strategyStartDate
                  .toDate()
                  .toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                .
              </Typography>
              {cprRecommendation && (
                <div className={classes.overviewSection}>
                  <Table className={classes.overviewTable}>
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} numeric header`}
                        >
                          Your Needs
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} numeric header`}
                        >
                          Your Selection
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} numeric header`}
                        >
                          {useWbiSingleStrategy
                            ? "Selected Portfolio"
                            : `Cy Optimized Portfolio`}{" "}
                          <sup>*</sup>
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} numeric header`}
                        >
                          {benchmarkName} <sup>**</sup>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          className={`${classes.tableCell} wrap-cell-head`}
                        >
                          {getRiskPeriod(currentPortfolio.metadata.riskPeriod)}{" "}
                          (Loss Tolerance)
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          <PercentageNumber
                            value={currentPortfolio.metadata.risk}
                            showSign={true}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          {useWbiSingleStrategy ? (
                            "--"
                          ) : currentPortfolio.metadata.solveFor === "risk" ? (
                            <PercentageNumber
                              value={parseFloat(currentPortfolio.metadata.cprRisk)}
                            />
                          ) : (
                            "--"
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          <PercentageNumber
                            value={
                              cprRecommendation.summary.recommendationSummary[
                                getRiskPeriodLossTolerance(
                                  portfolio.currentPortfolio.metadata.riskPeriod
                                )
                              ]
                            }
                            showSign={true}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          <PercentageNumber
                            value={
                              cprRecommendation.summary.benchmark[
                                getRiskPeriodLossTolerance(
                                  portfolio.currentPortfolio.metadata.riskPeriod
                                )
                              ]
                            }
                            showSign={true}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={`${classes.tableCell} wrap-cell-head`}
                        >
                          Annualized Rate of Return (RRoR)
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          <RRoR rrorValue={currentPortfolio.metadata.rror} />
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          {useWbiSingleStrategy ? (
                            "--"
                          ) : currentPortfolio.metadata.solveFor === "ret" ? (
                            <PercentageNumber
                              value={parseFloat(currentPortfolio.metadata.cprRror)}
                            />
                          ) : (
                            "--"
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          <PercentageNumber
                            value={
                              cprRecommendation.summary.recommendationSummary
                                .AnnualizedReturn
                            }
                            showSign={true}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          className={`${classes.tableCell} wrap-cell-highlighted`}
                        >
                          <PercentageNumber
                            value={
                              cprRecommendation.summary.benchmark.AnnualizedReturn
                            }
                            showSign={true}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              )}
            </React.Fragment>
          )}

          {cprRecommendation && (
            <section className={classes.summarySection}>
              {!isBasicView(accessLevel) && (
                <SectionHeader
                  text={
                    useWbiSingleStrategy
                      ? `Selected Portfolio`
                      : `Cy Optimized Portfolio`
                  }
                />
              )}
              <Typography variant="subtitle1">
                Hypothetical Illustration
              </Typography>
              <Typography paragraph={false}>
                Investment Amount |{" "}
                <Typography
                  display={"inline"}
                  paragraph={false}
                  color={"primary"}
                >
                  <CurrencyNumber
                    value={currentPortfolio.metadata.initialInvestment}
                  />
                </Typography>
              </Typography>
              {managerList && currentPortfolio.metadata.riskPeriod && (
                <React.Fragment>
                  <Typography variant="subtitle1" className={classes.subtitle}>
                    {cprRecommendation.displayName
                      ? `${cprRecommendation.displayName}`
                      : ""}
                  </Typography>
                  <Typography>
                    {baseChartData
                      ? moment(baseChartData[0].date)
                        .startOf("month")
                        .subtract(2, "months")
                        .format("MMM YYYY")
                      : "Jan 2000"}{" "}
                    to {END_OF_CPR_YEAR.format('MMM YYYY')}
                  </Typography>
                  <CyPortfolioDetailsSortable
                    strategyStartDate={strategyStartDate}
                    managerList={managerList}
                    portfolioSummary={cprRecommendation.summary}
                    finalWealth={baseChartData.slice(-1)[0]}
                    finalWealthWithAnnualWithdrawal={
                      annualWithdrawalChartData
                        ? annualWithdrawalChartData.slice(-1)[0]
                        : null
                    }
                    riskPeriod={currentPortfolio.metadata.riskPeriod}
                    totalWithdrawal={totalWithdrawal}
                  />
                  {/* <CyPortfolioImplementation managerList={managerList} /> */}
                </React.Fragment>
              )}
              {currentPortfolio.metadata.riskPeriod && (
                <CyComparison
                  summaryData={cprRecommendation.summary}
                  finalWealth={baseChartData.slice(-1)[0]}
                  finalWealthWithAnnualWithdrawal={
                    annualWithdrawalChartData
                      ? annualWithdrawalChartData.slice(-1)[0]
                      : null
                  }
                  riskPeriod={currentPortfolio.metadata.riskPeriod}
                />
              )}

              <Grid container={true} style={{ marginTop: 24 }}>
                <Grid item={true} xs={12}>
                  <CyLineChart
                    showTooltip={true}
                    data={baseChartData}
                    initialInvestment={
                      currentPortfolio.metadata.initialInvestment
                    }
                    renderForPdfOutput={this.renderForPdfOutput}
                    portfolioName={currentPortfolio.name}
                    benchmarkName={benchmarkName}
                  />
                </Grid>
                {annualWithdrawalChartData && (
                  <React.Fragment>
                    <Grid item xs={12}>
                      <CyTotalIncomeChart
                        data={totalWithdrawal}
                        initialInvestment={
                          currentPortfolio.metadata.initialInvestment
                        }
                        annualWithdrawal={
                          currentPortfolio.metadata.annualWithdrawal
                        }
                        strategyName={
                          currentPortfolio.cprRecommendation.displayName || ""
                        }
                        benchmarkName={benchmarkName}
                        endingCapitalData={
                          annualWithdrawalChartData[
                            annualWithdrawalChartData.length - 1
                          ]
                        }
                      />
                    </Grid>
                    <Grid item={true} xs={12}>
                      <CyLineChart
                        data={annualWithdrawalChartData}
                        initialInvestment={
                          currentPortfolio.metadata.initialInvestment
                        }
                        showTooltip={true}
                        withAnnualWithdrawal={true}
                        renderForPdfOutput={this.renderForPdfOutput}
                        portfolioName={currentPortfolio.name}
                        benchmarkName={benchmarkName}
                      />
                    </Grid>
                  </React.Fragment>
                )}
                <HighLevelDisclosure />
                <Grid item={true} xs={12}>
                  <SeeImportantDisclosures
                    style={{ position: "relative", marginTop: 16 }}
                  />
                </Grid>
              </Grid>
            </section>
          )}
          {cprRecommendation && (
            <Grid container={true}>
              <Grid item xs={12}>
                <CyMonteCarlo
                  initialInvestment={portfolio.currentPortfolio.metadata.initialInvestment}
                  mean={parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedReturn)}
                  sd={parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedStandardDeviation)}
                  startDate={strategyStartDate}
                />
              </Grid>
            </Grid>
          )}

          {cprRecommendation && (
            <section className={`${classes.summarySection}`}>
              <SectionCaption>
                Let’s review some additional information about the{" "}
                {useWbiSingleStrategy
                  ? "selected portfolio"
                  : `Cy optimized portfolio and manager strategies`}
                .
              </SectionCaption>
              <Grid container={true}>
                <Grid item={true} xs={10}>
                  <CyPortfolioRiskMetrics
                    startDate={strategyStartDate.format("MM/DD/YYYY")}
                    managerList={managerList}
                    portfolioDisplayName={cprRecommendation.displayName || ""}
                    portfolioSummary={cprRecommendation.summary}
                    useWbiSingleStrategy={useWbiSingleStrategy}
                  />
                </Grid>
                <Grid item={true} xs={10}>
                  <CyPortfolioReturn
                    startDate={strategyStartDate.format("MM/DD/YYYY")}
                    managerList={managerList}
                    portfolioDisplayName={cprRecommendation.displayName || ""}
                    portfolioSummary={cprRecommendation.summary}
                    useWbiSingleStrategy={useWbiSingleStrategy}
                  />
                  <HighLevelDisclosure showClause={[1]} />
                </Grid>
                <Grid item={true} xs={10}>
                  <SeeImportantDisclosures
                    style={{ position: "relative", marginTop: 16 }}
                  />
                </Grid>
              </Grid>
            </section>
          )}
          {cprRecommendation.calendarYearReturn &&
            cprRecommendation.calendarYearReturn.startYear &&
            cprRecommendation.calendarYearReturn.CprCalYearReturn &&
            cprRecommendation.calendarYearReturn.BenchmarkCalYearReturn && (
            <React.Fragment>
              <Typography variant="subtitle1" className={classes.subtitle}>
                Cy Calendar Year Return
              </Typography>
              <Grid container={true}>
                <Grid item={true} xs={10}>
                  <CyPortfolioCalendarYearReturnTable
                    portfolioDisplayName={cprRecommendation.displayName || ""}
                    calendarYearReturnData={
                      cprRecommendation.calendarYearReturn
                    }
                    benchmarkName={benchmarkName}
                  />
                </Grid>
              </Grid>
            </React.Fragment>
          )}

          {!isBasicView(accessLevel) && (
            <React.Fragment>
              <section className={`${classes.summarySection}`}>
                <SectionCaption>
                  Let’s also review the data and assumptions{" "}
                  {!useWbiSingleStrategy && 'Cy'} used to estimate your{" "}
                  <b>
                    <RRoR rrorValue={currentPortfolio.metadata.rror} />
                  </b>{" "}
                  Required Rate of Return.
                </SectionCaption>
                {/*
                currentPortfolio.clientProfiles is the snapshot of the client at the time when this portfolio is created,
                currentPortfolio.Household.Clients is a hack to those portfolios that don't have a client profile snapshot due to a bug
                */}
                <CyPortfolioOverview
                  advisorConfig={currentPortfolio.metadata.advisorConfig}
                  clients={clientProfileSnapshot.sort((c1, c2) => c1.profile.primary === true && c2.profile.primary === false ? -1 : 1)}
                />
              </section>
              {
                !app.hideFeeSchedule && (
                  <section className={`${classes.summarySection}`}>
                    <Grid container>
                      <Grid item xs={12} sm={5}>
                        <PortfolioFeeSummary
                          appName={appName}
                          managerList={managerList}
                          custodians={custodians}
                          onboardedCustodianId={onboardedCustodianId}
                          portfolioInvestment={
                            currentPortfolio.metadata.initialInvestment
                          }
                          cyPlatformFees={fee.cyPlatformFees}
                          userPlatformFees={userPlatformFees}
                          userCustodianFees={userCustodianFees}
                          portfolioAdvisorFee={advisorFee}
                          accessLevel={accessLevel}
                        />
                      </Grid>
                    </Grid>
                  </section>
                )
              }
            </React.Fragment>
          )}

          <section
            className={`${classes.summarySection} ${
              this.renderForPdfOutput ? classes.hiddenPrint : ""
            }`}
          >
            <SectionHeader text={"Important Information"} />
            <SummaryDisclosures
              portfolioDisplayName={cprRecommendation.displayName || ""}
              data={
                {
                  "MC_PORTFOLIO_RETURN": parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedReturn),
                  "MC_STANDARD_DEVIATION": parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedStandardDeviation),
                  "MC_START_DATE":cprRecommendation.chartData.startDate
                }
              }
            />
          </section>

          { app.modelDisclosureEnabled &&
            cprRecommendation &&
            cprRecommendation.modelConstituentDisclosure &&
            cprRecommendation.modelConstituentDisclosure.length > 0 && (
              <section className={`${classes.summarySection}`}>
                <Typography
                  variant="subtitle1"
                  style={{ margin: "30px 0 10px", fontWeight: 500 }}
                >
                  Model Constituent Disclosure
                </Typography>
                <CyPortfolioModelConstituentDisclosure
                  modelConstituentDisclosure={
                    cprRecommendation.modelConstituentDisclosure
                  }
                  managerList={managerList}
                  userIsApproved={user.user.approved}
                />
              </section>
            )}
        </div>
      </div>
    );
  }
}

Summary.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  portfolio: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  let portfolioId = ownProps.match.params.portfolioId;
  let householdId = ownProps.match.params.householdId;
  let userId = state.user.user.id;

  const { custodians } = state.custodian;
  const { userCustodianFees, userPlatformFees, portfolioAdvisorFeeRates } =
    state.fee;

  return {
    app: state.app,
    brokerDealer: state.user.user.brokerDealer,
    currentHouseholdId: householdId,
    currentPortfolioId: portfolioId,
    custodians,
    quik: state.quik,
    fee: state.fee,
    portfolio: state.portfolio,
    portfolioAdvisorFee: portfolioAdvisorFeeRates[portfolioId],
    user: state.user,
    accessLevel: state.user.user.userRole.accessLevel,
    userCustodianFees: userCustodianFees[userId],
    userPlatformFees: userPlatformFees[userId],
    appName: state.app.appName,
  };
};
export default withRouter(
  withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Summary))
);



// WEBPACK FOOTER //
// ./src/containers/PortfolioSummary/index.jsx